export default class MessageForm {
  public content: string = ''
  public targetableId: number
  public targetableType: string = ''
  public threadId: string = ''
  public courseId?: number
  public clientRequestId?: string
  public attachmentIds: number[] = []
  public metadata: any = {}
  public activeView?: { kind: string; examId?: number; userExamId?: number; phase?: string; questionIds?: number[] }
  public aiChatQuestionId: number = null
  public agentId: number = null
  public modelId: string = null
  public thinkingEnabled: boolean = true
  public message?: { content: string } // Support legacy format

  constructor(data?: any) {
    if (data) {
      // Handle legacy format { message: { content: string } }
      if (data.message && data.message.content) {
        this.content = data.message.content
      } else if (data.content) {
        this.content = data.content
      }

      // Set other properties
      if (data.targetableId) this.targetableId = data.targetableId
      if (data.targetableType) this.targetableType = data.targetableType
      if (data.threadId) this.threadId = data.threadId
      if (data.courseId) this.courseId = data.courseId
      if (data.clientRequestId) this.clientRequestId = data.clientRequestId
      if (data.attachmentIds) this.attachmentIds = data.attachmentIds
      if (data.metadata) this.metadata = data.metadata
      if (data.aiChatQuestionId) this.aiChatQuestionId = data.aiChatQuestionId
      if (data.agentId) this.agentId = data.agentId
      if (data.modelId) this.modelId = data.modelId
      if (data.thinkingEnabled !== undefined) this.thinkingEnabled = data.thinkingEnabled
    }
  }
}
